import React from 'react';

import groupBy from 'lodash/groupBy';

import Activity from './activity';
import { formatDate, MONTH_DAY_YEAR_FORMAT } from 'helpers/formatters/date_time_formats';

import type { Activity as ActivityProps } from './types';
import type { Parent } from 'bundles/crm/types';

interface Props {
  activities: ActivityProps[];
  currentParent?: Parent | Parent[];
  hasFilters: boolean;
  forUserId?: number;
  isBackofficeAdmin?: boolean;
  options?: object;
  showParents?: boolean | 'path';
  tagText?: string;
  onDelete: (activity: ActivityProps) => void;
  onSave: (activity: ActivityProps) => void;
}

export default function ActivityList({ activities, hasFilters, showParents, ...props }: Props) {
  const activityProps = { hasFilters, showParent: showParents, ...props };

  if (hasFilters) {
    return (
      <div className="d-flex flex-column gap-4">
        {activities.map(activity => (
          <Activity {...activityProps} activity={activity} key={activity.id} />
        ))}
      </div>
    );
  }

  const activitiesByHeader = groupBy(activities, activity => formatDate(activity.date, MONTH_DAY_YEAR_FORMAT));

  return <>
    {Object.keys(activitiesByHeader).map(header => (
      <div key={header}>
        <div className="d-flex align-items-center">
          <div className="my-3 me-2">
            <div className="fs-large fw-bold">{header}</div>
          </div>
          <hr className="m-0 flex-grow-1" />
        </div>

        <div className="d-flex flex-column gap-4">
          {activitiesByHeader[header].map(activity => (
            <Activity {...activityProps} activity={activity} key={activity.id} />
          ))}
        </div>
      </div>
    ))}
  </>;
}
